export const tabTaxProfiles = {
	addNewTaxProfile: "Agregar nuevo perfil",
	emptyTaxProfilesMessage: "No existen perfiles fiscales para mostrar",
	infosTaxProfile: {
		cnpj: "RFC",
		corporateName: "Razón Social",
		fantasyName: "Nombre Comercial",
		stateRegistration: "Registro Estatal",
		taxRegime: "Régimen Tributario",
		phone: "Teléfono",
		email: "E-mail",
	},
	optionsTaxation: {
		normalRegime: "Régimen normal",
		simpleNational: "Régimen simplificado",
		simpleNationalExcess: "Régimen simplificado exceso",
	},
	searchPlaceholder: "Buscar perfil fiscal",
};
